/**
 * based on https://lowrey.me/load-external-javascript-with-es6-promises/
 * @param url
 */
export const loadScript = (url: string) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.addEventListener('load', () => resolve(script), false);
    script.addEventListener('error', () => reject(script), false);
    document.body.appendChild(script);
});

/**
 * based on https://ourcodeworld.com/articles/read/630/how-to-detect-if-the-webp-image-format-is-supported-in-the-browser-with-javascript
 */
export const webPSupported = async (): Promise<boolean> => {
    // if the browser doesn't have the method createImageBitmap, you can't display webp format
    if (!window.createImageBitmap) return false;

    // base64 representation of a white point image
    const webpData = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';

    // retrieve the image in blob format
    const blob = await fetch(webpData).then(r => r.blob());

    // if the createImageBitmap method succeeds, return true, otherwise false
    return createImageBitmap(blob).then(() => true, () => false);
};
